/**
 * Pointer helpers.
 * Horizontal swipe detection exists so the UI can ignore scroll/drag gestures.
 * Swipes must never rotate the camera or change views.
 */

export const SWIPE_THRESHOLD_PX = 56;
export const SWIPE_DOMINANCE_RATIO = 1.35;

export interface PointerSample {
  x: number;
  y: number;
  time: number;
}

export type SwipeDirection = 'left' | 'right' | null;

export function classifyHorizontalSwipe(
  start: PointerSample,
  end: PointerSample,
): SwipeDirection {
  const dx = end.x - start.x;
  const dy = end.y - start.y;
  const absX = Math.abs(dx);
  const absY = Math.abs(dy);

  if (absX < SWIPE_THRESHOLD_PX) return null;
  if (absX < absY * SWIPE_DOMINANCE_RATIO) return null;

  // Finger moves right → reveal left view (natural pan), or opposite?
  // Common mobile pattern: swipe left = next / look right.
  return dx < 0 ? 'right' : 'left';
}

export function prefersReducedMotion(): boolean {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}
